import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{class:_vm.cssClass,attrs:{"label":_vm.label,"type":_vm.type,"placeholder":_vm.placeholder,"value":_vm.value,"rules":_vm.rules,"required":""},on:{"input":e=>_vm.$emit('input',e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }